<template>
  <grid-container class="sjt-container">
    <p>Our online Soft Skills Assessment Tool provides an analysis of your strengths and areas of improvement across multiple dimensions.</p>

    <p>Follow the instructions below to take our self-administering assessment to analyze your Soft Skills and begin to unlock your potential.</p>

    <br>

    <h5><u>Please keep a few things in mind before you begin the assessment:</u></h5>

    <ul>
      <li>We ask that you take your time in answering the questions.</li>
      <li>Try to keep distractions at a minimum while undergoing the assessment; such as closing all programs, including email.</li>
      <li>The average duration of the assessment is approximately 5 minutes for each skill (4 Questions per Skill)</li>
      <li>Even though there is no time limit, try answering as spontaneously as possible. You may only answer each question ONCE and you cannot go “Back” to change your answer once you have submitted your response.</li>
      <li>You will need a stable internet connection to take part in the assessment.</li>
      <li>The assessment has an autosave function so you can stop at any point and continue where you left off at a later date. This feature is also helpful for instances of temperamental internet connections.</li>
    </ul>

    <br>

    <h5><u>During the Assessment:</u></h5>

    <p>As part of the assessment process, you will be provided with a scenario or dilemma you need to resolve. In order to provide your response and move on to the next scenario; you will be required to provide <u><b>two responses</b></u> for each question.</p>

    <p>Specifically, you will be called to label which question you believe is the “Best Choice” to solve the problem - as well as indicate what you feel is the “Worst Choice” to solve the problem. Once you submit your two responses, you may proceed onto the next scenario.</p>

    <br>

    <h5><u>Support</u></h5>
    <p>If you have any questions, please contact us at <a class="link" href="mailto:info@owiwi.co.uk">info@owiwi.co.uk</a> and we will be happy to help!</p>

    <p><b>To begin the exam, click on “{{ $t('TakeTheTest') }}” below.</b></p>

    <br>

    <p><b>Best of Luck!</b></p>

    <br>

    <el-button @click="startTest" type="primary">
      {{ $t('TakeTheTest') }}
    </el-button>

    <ElDialog
      append-to-body
      title="Select Language"
      custom-class="dialog-size-550"
      :visible.sync="selectLang"
    >

      <div class="text-center">
        <el-radio-group v-model="language">
          <el-radio-button label="en">English</el-radio-button>
          <el-radio-button label="el">Ελληνικά - Greek</el-radio-button>
        </el-radio-group>
      </div>

      <span
        slot="footer"
        class="dialog-footer"
      >
        <ElButton
          type="primary"
          :disabled="!language"
          @click="selectLanguage()"
        >
          {{ $t('TakeTheTest') }}
        </ElButton>
      </span>
    </ElDialog>
  </grid-container>
</template>

<script>
import axios from '@/axios/axios'

export default {
  name: 'Start',
  computed: {
    langKey() {
      return this.$store.getters.langKey
    }
  },
  data() {
    return {
      selectLang: false,
      language: null
    }
  },
  methods: {
    startTest() {
      if (this.langKey) {
        this.selectLang = false
        this.$store.commit('startGame')
        this.$router.replace('/sjt')
      }
      else {
        this.selectLang = true
      }
    },

    selectLanguage() {
      axios.post('game/language', {
        playerResultId: this.$store.getters.playerResultId,
        langKey: this.language
      })
        .then(res => {
          this.$store.commit('langKey', this.language)
          this.$i18n.locale = this.language
          this.startTest()
        })
    }
  }
}
</script>

<style lang="scss" scoped>
  .link {
    font-weight: 600;
    text-decoration: underline;
  }
</style>
